<!-- @veltra/icons generated sha256:eb7d632acc79117f gen:8 source:src/svg/normal/sort-right.svg -->
<script setup lang="ts">
defineOptions({ name: 'SortRight' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M12.793 11H1.503A.503.503 0 0 1 1 10.5c0-.276.228-.5.504-.5h12.424a.53.53 0 0 1 .375.905l-3.595 3.594a.501.501 0 1 1-.706-.708z"
    />
  </svg>
</template>
